import Vue from "vue";
import DepartmentDetails from "./DepartmentDetails.vue";

export function load() {
    const selector = "department-details-component";
  // Is the custom Vue root element in the DOM?

  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: (createElement) =>
      createElement(DepartmentDetails, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
